import React from 'react';
import { cloudinaryForDisplay } from '../utils/cloudinary';

// Agent white-label card — shown on the live viewer + the gallery so the buyer
// sees the AGENT'S brand, not Peekr's. Returns null when there's no brand, so
// standard (non-realtor) rooms keep their plain Peekr UI untouched.
export default function AgentBrandCard({ agentBrand }) {
  if (!agentBrand || !agentBrand.agentName) return null;
  const { agentName, brokerage, phone, email, headshotUrl, logoUrl, accentColor } = agentBrand;
  const accent = accentColor || '#00D4FF';
  const initials = agentName.split(/\s+/).map((w) => w[0]).slice(0, 2).join('').toUpperCase();

  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 14,
        width: '100%', maxWidth: 480, margin: '0 auto',
        padding: '14px 16px', borderRadius: 18,
        background: 'rgba(10,14,24,0.72)',
        border: `1px solid ${accent}3A`,
        boxShadow: '0 10px 34px rgba(0,0,0,0.4)',
        textAlign: 'left',
      }}
    >
      {headshotUrl ? (
        <img
          src={cloudinaryForDisplay(headshotUrl, 200)}
          alt={agentName}
          style={{ width: 58, height: 58, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: `2px solid ${accent}` }}
        />
      ) : (
        <div style={{
          width: 58, height: 58, borderRadius: '50%', flexShrink: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: accent, color: '#06121E', fontWeight: 800, fontSize: 19,
        }}>{initials}</div>
      )}

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 16, color: '#EAF2FF', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {agentName}
        </div>
        {brokerage && (
          <div style={{ fontSize: 13, color: '#8FA3B8', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {brokerage}
          </div>
        )}
        {(phone || email) && (
          <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
            {phone && <a href={`tel:${phone}`} style={pill(accent)}>📞 Call</a>}
            {phone && <a href={`sms:${phone}`} style={pill(accent)}>💬 Text</a>}
            {email && <a href={`mailto:${email}`} style={pill(accent)}>✉️ Email</a>}
          </div>
        )}
      </div>

      {logoUrl && (
        <img
          src={cloudinaryForDisplay(logoUrl, 160)}
          alt=""
          style={{ height: 30, maxWidth: 72, objectFit: 'contain', flexShrink: 0, opacity: 0.92 }}
        />
      )}
    </div>
  );
}

function pill(accent) {
  return {
    display: 'inline-flex', alignItems: 'center', gap: 5,
    padding: '6px 13px', borderRadius: 999,
    background: `${accent}1A`, border: `1px solid ${accent}55`,
    color: accent, fontSize: 12.5, fontWeight: 600, textDecoration: 'none',
  };
}
